import { type FunctionalComponent, h } from '@stencil/core';
import Icon_Documents_pdf from '../../../../../../../assets/svg/doctypes-icons/Icon_Documents_pdf.svg';
import Icon_Documents_avi_audio_video from '../../../../../../../assets/svg/doctypes-icons/Icon_Documents_avi_audio_video.svg';
import Icon_Documents_CAD from '../../../../../../../assets/svg/doctypes-icons/Icon_Documents_CAD.svg';
import Icon_Documents_prsnt from '../../../../../../../assets/svg/doctypes-icons/Icon_Documents_prsnt.svg';
import type { ProductDocumentsData } from '../../../../../../../api/model/response/documents/public/ProductDocuments';
import type { TransformedRange } from '../../types/newProductCard.type';
import type { searcherName } from '../uiaas-search-product-dropdown-button/productDetails.types';

export interface ProductDropdownBodyContentDocuments {
  document: ProductDocumentsData | TransformedRange;
  isVisible: boolean;
  type: searcherName;
  itemsQuantity: number;
}

const getIconForDocTypeKey = key => {
    const iconClass = 'product-card-dropdown-content-data-item__icon';
    const iconSpan = svg => {
        return <span
          class={iconClass}
          innerHTML={svg}
        />;
    };

    switch (key) {
    case '12516104166': // Promotional video
    case '12516104258': // How to video
      return iconSpan(Icon_Documents_avi_audio_video);
    case '1555859': // CAD
      return iconSpan(Icon_Documents_CAD);
    case '1555872': // Presentation
      return iconSpan(Icon_Documents_prsnt);
    case '1555893': // Firmware
    case '1555896': // Software - Demos & Trial
    case '1555898': // Software - Release
    case '1555899': // Software - Hotfix
    case '90190412452': // Software - Data Library
      return <span
        class={iconClass}
      >
        <se-icon size="micro">file_placeholder</se-icon>
      </span>;
    default:
      return iconSpan(Icon_Documents_pdf);
    }
};

export const ProductDropdownBodyContentDocuments: FunctionalComponent<
  ProductDropdownBodyContentDocuments
> = (props) => {
    const { document, isVisible, type, itemsQuantity } = props;
    const title = 'f3Cat' in document ? document.f3Cat : document.title;

    if (title && document.openUrl)
      return (
        <li
          class={{
            'product-card-dropdown-content-data-item': true,
            'product-card-dropdown-content-data-item--ranges': type === 'Ranges',
            'product-card-dropdown-content-data-item--single': itemsQuantity === 1,
          }}
        >
          <a
            data-card-area="dropdown-link"
            class={{
              'product-card-dropdown-content-data-item__link': true,
              'product-card-dropdown-content-data-item__link--ranges': type === 'Ranges',
            }}
            href={document.openUrl}
            tabindex={isVisible ? '0' : '-1'}
          >
            {(type === 'Documents' && 'docType' in document) &&
              getIconForDocTypeKey(document.docType.key)
            }
            <span>{title}</span>
            {type === 'Ranges' ? (
              <se-icon size="nano">arrow2_right</se-icon>
            ) : (
              ''
            )}
          </a>
        </li>
      );
};
